<template>
    <section id="project_four_content">

        <div class="row" id="first_row">

            <!-- In Small Screen -->
            <h3 class="mt-4 mb-0 d-block d-lg-none">STEM.org</h3>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                    <h3 class="d-none d-lg-block">STEM.org</h3>

                    <p>هي منظومة أبحاث واستشارات وتطوير مهني واعتماد بمحتوى عربي لتطوير منظومة تعليم العلوم والرياضيات
                        والهندسة والتكنولوجيا بالشراكة مع منظمة STEM.org العالمية.</p>

                    <h5 class="mt-3">أبرز الخدمات التي يتم تقديمها</h5>

                    <ul class="mb-lg-0">
                        <li>
                            <span>أبحاث واستشارات في مجال STEM</span>
                        </li>
                        <li>
                            <span>اختبارات STEM</span>
                        </li>
                        <li>
                            <span>شهادات اجتياز برنامج STEM</span>
                        </li>
                        <li>
                            <span>اعتماد معمل STEM</span>
                        </li>
                        <li>
                            <span>اعتماد مدرب STEM</span>
                        </li>
                    </ul>

                    <h5 class="mt-3">ستيم العالمية</h5>

                    <p>هي أطول منظمة خاصة تعمل بشكل مستمر في مجال الأبحاث واعتماد العلوم والتكنولوجيا والهندسة والرياضيات
                        (STEM) في أمريكا. منذ عام 2001، ساعدت قيادتها في المبادرات الرئيسية التي كانت حاسمة للنمو الشامل
                        وانتشار الحركة، بما في ذلك العمل المبكر في تجمع الكونجرس للعلوم والتكنولوجيا والهندسة والرياضيات
                        لعام 2005. يُظهر فريقها الأفضل في علم أصول التدريس/علم الأندراغوجيا، ويدعم أفضل العلامات التجارية
                        والمنظمات في العالم وآلاف المعلمين على مستوى العالم.</p>

                </div>

            </div>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                <div class="col_two_content">
                    <div class="img_wrapper">
                        <img src="@/assets/images/projects/project_four_img.webp" alt="">
                    </div>
                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'ProjectFour',
}
</script>

<style lang="scss" scoped>
#project_four_content {

    #first_row {

        h3 {
            font-family: 'FFShamelFamily-Bold';
            color: $Green;
            font-size: 18px;
            line-height: 180%;
        }

        .col_one_content {

            p {
                color: $White;
                font-size: 16px;
                line-height: 180%;
                text-align: justify;
                margin-bottom: 0;
            }

            h5 {
                font-family: 'FFShamelFamily-Bold';
                font-size: 16px;
                line-height: 156%;
                color: $Green;
            }

            h5:nth-of-type(2n) {
                color: $Yellow;
            }

            ul {
                color: $White;
                font-size: 16px;
                line-height: 180%;
                padding-right: 0px;
                padding-left: 0px;
                text-align: justify;
                list-style-type: none;

                li {
                    display: table-row;

                    span {
                        display: table-cell;
                        vertical-align: middle;
                    }
                }

                li::before {
                    content: '';
                    display: inline-block;
                    margin-left: 8px;
                }

                li:first-child::before {
                    width: 24px;
                    height: 17px;
                    background-image: url('@/assets/images/projects/reserches.svg');
                    background-size: 24px 17px;
                }

                li:nth-child(2)::before {
                    width: 24px;
                    height: 24px;
                    background-image: url('@/assets/images/projects/test.svg');
                    background-size: 24px 24px;
                }

                li:nth-child(3)::before {
                    width: 24px;
                    height: 24px;
                    background-image: url('@/assets/images/projects/certificate1.svg');
                    background-size: 24px 24px;
                }

                li:nth-child(4)::before {
                    width: 24px;
                    height: 24px;
                    background-image: url('@/assets/images/projects/certificate2.svg');
                    background-size: 24px 24px;
                }

                li:nth-child(5)::before {
                    width: 24px;
                    height: 24px;
                    background-image: url('@/assets/images/projects/certificate3.svg');
                    background-size: 24px 24px;
                }
            }

        }

        // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
        .col_two_content {

            position: relative;

            width: 636px;
            height: 426px;

            @include breakpoints(x-small) {
                width: 351px;
                height: 235px;
            }

            @include breakpoints(small) {
                width: 516px;
                height: 345px;
            }

            @include breakpoints(medium) {
                width: 696px;
                height: 466px;
            }

            @include breakpoints(large) {
                width: 456px;
                height: 305px;
            }

            @include breakpoints(x-Large) {
                width: 546px;
                height: 366px;
            }

            background: $Green;
            box-sizing: border-box;

            // https://www.cssportal.com/css-clip-path-generator/
            // CSS Vendor Prefixes
            -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

            .img_wrapper {

                position: absolute;
                top: 1px;
                left: 1px;

                width: 634px;
                height: 424px;

                @include breakpoints(x-small) {
                    width: 349px;
                    height: 233px;
                }

                @include breakpoints(small) {
                    width: 514px;
                    height: 343px;
                }

                @include breakpoints(medium) {
                    width: 694px;
                    height: 464px;
                }

                @include breakpoints(large) {
                    width: 454px;
                    height: 303px;
                }

                @include breakpoints(x-Large) {
                    width: 544px;
                    height: 364px;
                }

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                // border: solid 2px $Green;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    opacity: 0.9;
                }

                img:hover {
                    opacity: 1;
                    -webkit-transition: opacity 0.5s linear 0.2s;
                    -moz-transition: opacity 0.5s linear 0.2s;
                    transition: opacity 0.5s linear 0.2s;
                }

            }

        }

    }

}
</style>